$(document).ready(function () {
    var isDragStart = false;
    var isDragging = false;
    var prevPageX; //urcuje kde zacal mouseStart (napr zacnu draggovat na obrazku mysi nekde 300px z leveho okraje webu, pak kdyz pohnu mysi o 1px doprava => zavola se funkce dragging(e) => [(300+1) - 300] => 1px)

    var slideshowScrollerWrapper = $('.product-card__slideshow__scroller-wrapper');
    var slideshowScrollerJS = document.querySelector('.product-card__slideshow__scroller');  //protoze jquery bez novejsi verze neumi nastavit style --position
    var slideshowScroller = $('.product-card__slideshow__scroller');

    var position = 0; //current translateX image wrapperu
    var positionBeforeDrag = 0; //translateX na zacatku dragovani galerie
    var scrollPositionTolerance = 10; //po 10% prescrollovani obrazku se obrazek po uvolneni mysi doscrolluje na cely obrazek
    var transitionDuration = 300; // doba scrollovani mezi obrazky v milisekundach (chtelo by to pocitat dynamicky, protoze treba poslednich 5px obrazku se bude taky doscrollovavat transitionDuration), treba rozmezi 150-400ms
    var imageSelectors = $('.product-card__slideshow__image-selector-wrapper .product-card__slideshow__image-selector');
    var maxPosition = imageSelectors.length == 0 ? scrollPositionTolerance : (imageSelectors.length * 100) - (100 - scrollPositionTolerance); //omezeni, kam az jde scrollovat obrazky (aby se zarazil na poslednim + positionTolerance aby se to hezky odrazelo pri narazu na konec)
    var minPosition = -scrollPositionTolerance; //kvuli odrazeni od zacatku scrollu, pokud se user snazi scrollovat doleva pres position 0 (do zapornych hodnot)
    var imageWidth = $('.product-card__slideshow__image').length > 0 ? $('.product-card__slideshow__image')[0].clientWidth : undefined;

    if (slideshowScrollerWrapper.length > 0) {
        bindImageSelectorEvents();

        slideshowScrollerWrapper.on("mousedown", function (e) {
            slideshowScroller.addClass('product-card__slideshow__scroller--dragging');
            dragStart(e);
        });

        slideshowScrollerWrapper.on("touchstart", function (e) {
            slideshowScroller.addClass('product-card__slideshow__scroller--dragging');
            dragStart(e);
        });

        $(document).on("mouseup", function () {
            slideshowScroller.removeClass('product-card__slideshow__scroller--dragging');
            dragStop();
        });

        slideshowScrollerWrapper.on("touchend", function () {
            slideshowScroller.removeClass('product-card__slideshow__scroller--dragging');
            dragStop();
        });

        $(document).on("mousemove", function (e) {
            dragging(e);
        });

        slideshowScrollerWrapper.on("touchmove", function (e) {
            dragging(e);
        });

        $(window).on("resize", function (e) {
            slideshowScrollerWrapper.css('width', ''); //přenastavuje se pevne sirka wrapperu, protoze kdyz sirka obrazku vychazi na necele cislo, tak jsou obrazky (krome prvniho) posunute pres translateX rozmazane
            imageWidth = $('.product-card__slideshow__image')[0].getBoundingClientRect().width;
            slideshowScrollerWrapper.css('width', Math.round(imageWidth) + 'px');
            $('.product-card__slideshow__image').css('width', Math.round(imageWidth) + 'px');
        });
    }

    function bindImageSelectorEvents() {
        imageSelectors.each(function (index, selector) {
            $(selector).on("click", function () {
                setPositionExact(index * 100, true);
            })
        });
    }

    function setPositionExact(positionExact, isInstant = false) {
        if (positionExact < minPosition) {
            position = minPosition;
        } else if (positionExact > maxPosition) {
            position = maxPosition;
        } else {
            position = positionExact;
        }

        if (isInstant == true) {
            slideshowScrollerJS.style.setProperty('--duration', '0ms');
        } else {
            slideshowScrollerJS.style.setProperty('--duration', transitionDuration + 'ms');
        }
        slideshowScrollerJS.style.setProperty('--position', position);
        updateSelectorActive();
    }

    function updateSelectorActive() {
        imageSelectors.each(function (index, selector) {
            var positionToIndex = Math.round(position / 100);
            if (index == positionToIndex) {
                $(selector).addClass('product-card__slideshow__image-selector--active');
            } else {
                $(selector).removeClass('product-card__slideshow__image-selector--active');
            }
        });
    }

    function dragging(e) {
        if (!isDragStart) return;
        var isMouseMoveEvent = e.type === 'mousemove';
        if (isMouseMoveEvent) {
            e.preventDefault();
        }
        isDragging = true;
        var positionDiff = (e.pageX || e.touches[0].pageX) - prevPageX;
        var pxOfImageInPositionPercentage = 1 / imageWidth; //kolik % sirky obrazku je 1px
        setPositionExact(positionBeforeDrag - (positionDiff * pxOfImageInPositionPercentage * 100));
    }

    function dragStart(e) {
        isDragStart = true;
        prevPageX = e.pageX || e.touches[0].pageX;
        positionBeforeDrag = position;
    }

    function dragStop() {
        isDragStart = false;
        if (!isDragging) return;
        isDragging = false;
        finishScrollToFullWidth();
    }

    function finishScrollToFullWidth() {
        var scrolledFromStart = position % 100;
        var roundTo = null;

        //smer vlevo
        if (
            position < positionBeforeDrag
            && ((scrolledFromStart) < (100 - scrollPositionTolerance))
        ) {
            if (position < 0) { //odrazeni od leveho konce
                roundTo = 0;
            } else {
                roundTo = roundDownToHundreds(position);
            }
            return setPositionExact(roundTo);
        }

        //smer vpravo
        if (
            position > positionBeforeDrag
            && ((scrolledFromStart) > (scrollPositionTolerance))
        ) {
            roundTo = roundUpToHundreds(position);
            return setPositionExact(roundTo);
        }

        //vraceni na pocatecni polohu
        roundTo = Math.round(position / 100) * 100;
        return setPositionExact(roundTo);
    }

    //zokrouhli nahoru na stovky
    //number(0.01 - 100) => 100
    function roundUpToHundreds(number) {
        return Math.ceil(number / 100) * 100;
    }

    //zaokrouhli dolu na stovky
    //number(0 - 99.999) => 0
    function roundDownToHundreds(number) {
        return Math.floor(number / 100) * 100;
    }
});
